// custom.js

$(function() {
    $("#nav-top").on( 'click', (event) => {
        event.preventDefault();
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#header-section").offset().top
        }, 100);
        $("#mainNavigation").removeClass('menu-opened');
    });
    $("#nav-pricing").on( 'click', (event) => {
        event.preventDefault();
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#pricing").offset().top
        }, 100);
        $("#mainNavigation").removeClass('menu-opened');
    });
    $("#nav-faqs").on( 'click', (event) => {
        event.preventDefault();
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#faqs").offset().top
        }, 100);
        $("#mainNavigation").removeClass('menu-opened');
    });
    $("#nav-location").on( 'click', (event) => {
        event.preventDefault();
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#location").offset().top
        }, 100);
        $("#mainNavigation").removeClass('menu-opened');
    });
    $("#nav-contact").on( 'click', (event) => {
        event.preventDefault();
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#contact").offset().top
        }, 100);
        $("#mainNavigation").removeClass('menu-opened');
    });



});

